<template>
  <div class="container">
    <ModalTokenConfirm
      :show="preparedModal.show"
      @close="preparedModal.show = false"
      @confirm="removeToken($event, true)"
      :title="$t('message.modal_confirm_token_title')"
      :content="$t('message.modal_confirm_token_text')"
      :cancel="$t('message.modal_confirm_token_cancel_button')"
      :confirm="$t('message.modal_confirm_token_confirm_button')"
    />
    <div class="row">
      <div class="col-xs-12">
        <h1>{{ $t('message.my_token') }}</h1>
        <p>
          {{ $t('message.token_description_1') }}
          <a
            href="https://www.gs1-germany.de/serviceverzeichnis/verified-by-gs1/"
            target="_blank"
            rel="noopener"
            >{{ $t('message.registry_platform') }}</a
          >
          {{ $t('message.before_swagger_link') }}
          <a
            href="/api/verified_service/swagger-ui/index.html"
            target="_blank"
            rel="noopener"
            >{{ $t('message.token_description_3') }}</a
          >.
          {{ $t('message.token_description_2') }}
        </p>
      </div>
    </div>
    <div class="row" style="margin: 1% 0">
      <div class="col-md-6" style="padding-left: 0">
        <button
          @click="createToken"
          class="btn btn-xs"
          :class="'btn-primary'"
          role="button"
          tag="button"
          :title="$t('message.token_tooltip')"
        >
          <span class="glyphicon glyphicon-plus"></span>
          {{ $t('message.create_new_token') }}
        </button>
      </div>
      <div class="col-md-6 text-right">
        <a
          type="button"
          :href="
            SIMBA_SERVICE_BASE_URL +
            '/api/verified_service/swagger-ui/index.html'
          "
          target="_blank"
          class="btn btn-xs"
          role="button"
          tag="button"
          :title="$t('message.api_docs_tooltip')"
          >API Docs <span class="glyphicon glyphicon-search"></span
        ></a>
      </div>
    </div>
    <div style="display: inline">
      <div class="table-responsive">
        <table class="small table table-striped">
          <thead>
            <tr>
              <th>
                <a href="#">{{ $t('message.token_id') }}</a>
              </th>
              <th>
                <a href="#">{{ $t('message.username') }}</a>
              </th>
              <th>
                <a href="#">{{ $t('message.comapany_name') }}</a>
              </th>
              <th>
                <a href="#">{{ $t('message.tokens') }}</a>
              </th>
              <th>
                <a href="#">{{ $t('message.revocation') }}</a>
              </th>
            </tr>
          </thead>
          <tbody v-if="tokens.length == 0">
            <tr>
              <td colspan="8" class="text-center text-muted">
                {{ $t('message.no_token_found') }}
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="loading">
            <tr>
              <td colspan="8" class="text-center text-muted">
                <i class="fas fa-spinner fa-spin"></i>
                {{ $t('message.loading') }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(token, index) in tokens" :key="token.id">
              <td>
                {{ token.id }}
              </td>
              <td>
                {{ token.username }}
              </td>
              <td>
                {{ token.companyName }}
              </td>
              <td>
                <input readonly style="width: 381px" :value="token.token" />
                <button v-clipboard="() => token.token">
                  {{ $t('message.copy') }}
                </button>
              </td>
              <td scope="row" class="trashIconContainer">
                <i
                  class="far fa-trash-alt"
                  style="cursor: pointer"
                  @click="deleteToken(index, token.id)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { createHttpClient } from '../../http'
import qs from 'qs'
import ModalTokenConfirm from '@/components/ModalTokenConfirm'
import InfoIconWithExplanationModal from '@/components/InfoIconWithExplanationModal'
import { SIMBA_SERVICE_BASE_URL } from '../../main'
import { refresh } from '../../auth'

var _apiClient = null
function getApiClient() {
  if (!_apiClient) {
    _apiClient = createHttpClient(
      SIMBA_SERVICE_BASE_URL + '/api/token_service/v1'
    )
  }
  return _apiClient
}

export default {
  name: 'Token',
  components: {
    InfoIconWithExplanationModal,
    ModalTokenConfirm
  },
  data() {
    return {
      loading: false,
      tokens: [],
      id: '',
      index: '',
      preparedModal: {
        show: false
      }
    }
  },
  created() {
    this.load()
  },
  watch: {
    $route: 'load'
  },
  computed: {
    SIMBA_SERVICE_BASE_URL() {
      return SIMBA_SERVICE_BASE_URL
    }
  },
  methods: {
    createToken() {
      getApiClient()
        .post('/token', undefined)
        .then(response => {
          this.load()
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401 || error.response.status === 403) {
            refresh().then(() => {
              console.log('Successfully refreshed access!')
            })
          }
        })
    },
    deleteToken(index, id) {
      this.preparedModal.show = true
      this.index = index
      this.id = id
    },
    removeToken(e, confirmed) {
      if (confirmed) {
        this.tokens.splice(this.index, 1)
        getApiClient()
          .delete('/token/' + this.id)
          .then(response => {})
          .catch(error => {
            console.log(error)
            if (
              error.response.status === 401 ||
              error.response.status === 403
            ) {
              refresh().then(() => {
                console.log('Successfully refreshed access!')
              })
            }
          })
      }
      this.preparedModal.show = false
      this.index = ''
      this.id = ''
    },
    load() {
      // load tokens from backend
      const queryString = qs.stringify(this.$route.query, {
        arrayFormat: 'repeat'
      })
      const url = '/token' + (queryString ? '?' + queryString : '')
      this.loading = true
      getApiClient()
        .get(url)
        .then(response => {
          this.tokens = response.data
          this.loading = false
        })
        .catch(error => {
          if (error.response.status === 401 || error.response.status === 403) {
            refresh().then(() => {
              console.log('Successfully refreshed access!')
            })
          }
        })
    }
  }
}
</script>

<style scoped>
.btn[disabled] {
  cursor: not-allowed;
  pointer-events: all !important;
}

.toolkit .form-search-box input,
.toolkit .form-search-box > div {
  height: 37px;
}

.table th a {
  color: #000;
  font-weight: 700;
}

.table td a {
  color: #000;
  font-weight: 300;
}

.table a:hover {
  text-decoration: underline;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  vertical-align: middle;
}

.selection ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.toolkit .content-module a {
  font-weight: 500;
}

.toolkit .content-module a[role='button'] {
  display: block;
  margin: 10px 0 0 0 !important;
}

.toolkit .content-module a[role='button']:nth-of-type(1) {
  margin-top: 15px !important;
}

.toolkit .content-module a[role='button'][disabled] {
  cursor: not-allowed;
  pointer-events: all !important;
}

.toolkit .content-module li {
  border: 0;
  padding: 2px 0;
}

/* toolbar */
.toolbar .col-sm-12 {
  margin-bottom: 20px;
}

.toolkit a[role='button'] + a[role='button'] {
  margin: 0;
}

.button {
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.containerBtns {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/router/views/Token.vue